import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';

const WhatIsCountdownPopover = () => (
    <>
        <Info
            color="primary"
            id="what-is-countdown-popover-trigger"
            size="sm"
            style="fill"
        />
        <Tooltip
            anchorSelect="#what-is-countdown-popover-trigger"
            place="left"
        >
            <FormattedMessage id="itemBidding.dontWait" />
        </Tooltip>
    </>
);

export default WhatIsCountdownPopover;
